import React from "react";

const ErrorTestComponent = () => {
  throw new Error("This is a test error!");
};

export default ErrorTestComponent;
